/**
 * websocket code
 */
export default {
  // 发送
  SEND_CODE_HEART: 0, // 心跳
  SEND_CODE_HEALTHY: 10002, // 设备健康
  SEND_CODE_DETAIL: 10003, // 设备详细信息
  SEND_CODE_THRESHOLD: 10004, // 阈值信息
  // 收到
  WS_DANGE1: 301, // 预警
  WS_DANGE2: 302, // 报警或报警升级
  WS_CLEAR_DANGE: 303, // 清除报警
  WS_FAIL: 500, // 服务异常(token失效或者ws断开)
  WS_DETAIL: 30801, // 设备详细数据
  WS_BASIC: 30802, // 设备基本信息
  WS_DEVICE: 30803, // 设备状态信息
  WS_THRESHOLD: 30804 // 阈值信息
};
